// Tendencia de "Utilización de la capacidad instalada" — componente React/Tremor.
// Toma los mismos datos del heatmap (UtilizacionData) y grafica, para cada mes,
// la UTILIZACIÓN TOTAL promedio de todas las franjas (línea de tendencia mensual).
import { useMemo } from "react";
import { Card, Title, Text, LineChart } from "@tremor/react";
import { PALETTE } from "../lib/palette";
import type { UtilizacionData } from "./HeatmapUtilizacion";

export default function TendenciaUtilizacionCapacidad({ data }: { data: UtilizacionData }) {
  // Utilización total por mes = promedio de utilizacion_pct de las franjas con dato.
  const serie = useMemo(() => {
    return data.meses.map((m) => {
      const vals = data.celdas
        .filter((c) => c.mm === m.mm && c.utilizacion_pct != null)
        .map((c) => c.utilizacion_pct as number);
      const prom = vals.length
        ? vals.reduce((a, b) => a + b, 0) / vals.length
        : null;
      return {
        mes: m.label,
        mm: m.mm,
        utilizacion: prom != null ? Number(prom.toFixed(1)) : null,
      };
    });
  }, [data]);

  const hayDatos = serie.some((s) => s.utilizacion != null);

  return (
    <Card className="!p-3">
      <Title className="!text-base">Tendencia de utilización (total por mes)</Title>
      <Text className="!text-xs">
        Promedio de la utilización de todas las franjas · % mensual
        {data.capacidad_sillas ? ` · ${data.capacidad_sillas} asientos` : ""}
      </Text>
      {hayDatos ? (
        <LineChart
          className="mt-3 h-64"
          data={serie}
          index="mes"
          categories={["utilizacion"]}
          colors={[PALETTE.primaryDark]}
          curveType="monotone"
          valueFormatter={(v: number) => `${v.toFixed(1)}%`}
          yAxisWidth={48}
          showLegend={false}
          showAnimation={false}
          style={{ ["--tr-line-chart-stroke-width" as any]: "2px" }}
        />
      ) : (
        <Text className="mt-3 !text-xs text-tremor-content">
          Sin datos de ocupabilidad para graficar la tendencia.
        </Text>
      )}
    </Card>
  );
}
